<template>
  <div class="ts-app-shell_fh">
    <CheckListTemplate :currentPage="currentPageStep">
      <div class="check-list-form">
        <div class="content-type">
          <span class="numeral-item">9.</span>
          <span>Dislocated Worker</span>
        </div>
        <p>Please enter your information regarding your eligibility in WIOA.</p>
        <el-form @submit.native.prevent="updateCheckList">
          <div class="content-type">
            <p class="heavy-text">Category 4</p>
          </div>
          <div class="content-type">
            <p class="heavy-text">Displaced Homemaker</p>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you an individual who has been providing unpaid services
                  to family members in the home?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.DislocatedWorker.CategoryFour.UnpaidServices.IsProvidingUnpaidServices'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      dislocatedWorker.categoryFour.unpaidServices
                        .isProvidingUnpaidServices
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you unemployed or underemployed and are experiencing
                  difficulty in obtaining or upgrading employment?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.DislocatedWorker.CategoryFour.Employment.IsExperiencingDifficultyObtainingEmployment'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      dislocatedWorker.categoryFour.employment
                        .isExperiencingDifficultyObtainingEmployment
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Have you been dependent on the income of another family member
                  but is no longer supported by that income?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.DislocatedWorker.CategoryFour.DependentOnIncome.IsDependentOnIncomeOfAnotherFamilyMember'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      dislocatedWorker.categoryFour.dependentOnIncome
                        .isDependentOnIncomeOfAnotherFamilyMember
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you a dependent spouse of a member of the Armed Forces on
                  active duty and whose family income is significantly reduced
                  because of a deployment, a call or order to active duty, a
                  permanent change of station, or the service connected death or
                  disability of the member?
                </label>
                <el-form-item
                  :error="
                    retrieveFieldError(
                      modelState,
                      'WioaChecklistRequest.DislocatedWorker.CategoryFour.DependentSpouse.IsDependentSpouseOfAMemberOfArmedForces'
                    )
                  "
                >
                  <el-radio-group
                    v-model="
                      dislocatedWorker.categoryFour.dependentSpouse
                        .isDependentSpouseOfAMemberOfArmedForces
                    "
                    class="ml-4"
                  >
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-item">
            <el-row>
              <el-col :xl="24" :lg="24" :md="24" :sm="24">
                <p>
                  Please upload documentation confirming your status as a
                  displaced homemaker.
                </p>
                <el-form-item>
                  <el-upload
                    drag
                    action="dependentSpouse"
                    :on-exceed="handleExceed"
                    limit="1"
                    ref="upload"
                    class="upload-icon dependentSpouse"
                    :accept="validFileExtensions.map(i => `.${i}`).join(',')"
                    :auto-upload="true"
                    :http-request="uploadDocument"
                    :before-upload="beforeUpload"
                    :on-error="onError"
                    :on-remove="removeUpload"
                    :file-list="dependentSpouseFileList"
                  >
                    <i class="fa fa-upload" />
                    <div class="el-upload__text">
                      Drop file here or <em>click to upload</em>
                    </div>
                  </el-upload>
                  <p class="heavy-font">
                    What documentation can confirm my status?
                    <em @click="showDisplacedHomeMakerDialog">Click here</em>
                  </p>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="content-item action-section">
            <el-row>
              <el-col :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-outline wioa-btn-outline"
                  @click="backToDashboard"
                >
                  Previous
                </el-button>
              </el-col>
              <el-col :offset="2" :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-secondary"
                  @click="updateCheckList"
                >
                  Continue
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <el-dialog
          style="z-index: 1000;"
          :visible="displayDisplacedHomeMakerDialog"
          :show-close="true"
          width="750px"
        >
          <div slot="title">
            <el-row>
              <el-col
                :xl="24"
                :lg="24"
                :md="24"
                :xs="24"
                :sm="24"
                style="height: 80px; padding: 15px 0px 15px 0px; text-align: left"
              >
                <span style="font-size: 25px;"><b>Displaced Homemaker</b></span
                ><br />
                <span style="font-size: 15px;"
                  >What documentation can confirm my status?</span
                >
              </el-col>
            </el-row>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="el-dialog__headerbtn"
            @click="closeDisplacedHomeMakerDialog"
          >
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>

          <el-divider></el-divider>
          <el-row style="word-break: break-word;">
            <el-col
              :xl="24"
              :lg="24"
              :md="24"
              :xs="24"
              :sm="24"
              style="padding: 15px 0px 15px 0px; text-align: left"
            >
              <span>-Self-attestation </span><br />
              <span>-Signed intake application or enrollment form </span><br />
              <span>-Public assistance records </span><br />
              <span>-Spouse’s layoff notice </span><br />
              <span>-Spouse’s death record </span><br />
              <span
                >-Spouse’s Permanent Change of Station (PCS) orders (for
                military move or assignment) </span
              ><br />
              <span>-Divorce records </span><br />
              <span>-Applicable court records </span><br />
              <span
                >-Bank records (showing financial dependence on spouse, no
                separate individual income support, or no employment income
                earned) </span
              ><br />
              <span>-Needs assessment from partner program </span><br />
              <span
                >-Signed Individual Employment Plan (IEP) from partner
                program</span
              ><br />
            </el-col>
          </el-row>
        </el-dialog>
      </div>
    </CheckListTemplate>
    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import CheckListTemplate from "../../component/checkListTemplate.vue";
import TSLoading from "../../../../components/TSLoading.vue";
import { BucketType } from "@/enums";
import * as utils from "@/utils";

export default {
  components: { CheckListTemplate, TSLoading },
  data() {
    return {
      displayDisplacedHomeMakerDialog: false,
      modelState: {},
      loading: false,
      dependentSpouseFileList: [],
      dislocatedWorker: {
        categoryFour: {
          unpaidServices: { isProvidingUnpaidServices: null },
          employment: { isExperiencingDifficultyObtainingEmployment: null },
          dependentOnIncome: { isDependentOnIncomeOfAnotherFamilyMember: null },
          dependentSpouse: {
            isDependentSpouseOfAMemberOfArmedForces: null,
            clientFiles: []
          },
          displacedHomemakerFiles: []
        }
      },
      newDependentSpouseUploadInd: false,
      validFileExtensions: [
        ...utils.imageFileExtensions,
        ...utils.documentFileExtensions
      ],
      document: {
        type: Object,
        default() {
          return {
            id: "",
            name: "",
            filename: "",
            documentObjectId: "",
            documentObjectUrl: "",
            isImage: false
          };
        }
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.path.match("wioa/complete-checklist/") == null) {
      this.$confirm("Are you sure you want to leave this page?", "Warning!", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
        type: "warning",
        center: true
      })
      .then(() => {
        if(this.newDependentSpouseUploadInd)
        {
            if(this.dislocatedWorker.categoryFour.dependentSpouse.clientFiles[0].fileId && this.newDependentSpouseUploadInd){
              this.navigateAwayRemoveAttachment(this.dislocatedWorker.categoryFour.dependentSpouse.clientFiles[0].fileId);
              this.dislocatedWorker.categoryFour.dependentSpouse.clientFiles = [];
            }

            this.$message.success("Your checklist are saved as draft!");
            localStorage.removeItem("editChecklist");
            next();
        }
        else
        {
          this.$message.success("Your checklist are saved as draft!");
          localStorage.removeItem("editChecklist");
          next();
        }
      })
      .catch(() => false);
    } else {
      next();
    }
  },
  created() {
    window.scrollTo(0,0);
    if (this.editChecklistId) {
      this.loading = true;
      this.$store
        .dispatch("wioa/getChecklistToReview", this.editChecklistId)
        .then(res => {
          // this.dislocatedWorker = res.checklist.dislocatedWorker;
          if (res.checklist.dislocatedWorker.categoryFour)
          {
            this.dislocatedWorker.categoryFour = res.checklist.dislocatedWorker.categoryFour;
            res.checklist.dislocatedWorker.categoryFour.dependentSpouse.clientFiles.forEach(element => {
              this.dependentSpouseFileList.push({'name': element.fileName, 'url': element.fileId});
            });
          }
            
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    navigateAwayRemoveAttachment(objectId){
      const param = {
          objectId: objectId,
          bucketType: BucketType.WioaChecklist,
        };
        this.$store
          .dispatch("common/removefile", param)
          .then(() => {
            return true;
          })
          .catch((res) => {
            this.$message.success("Something went wrong. Please contact talentsensus admin.");
            return false
          });
    },
    removeUpload(file, fileList){
      let uploadElement = event.target.parentElement.parentElement.parentElement;
      this.loading = true;
      file.url = (file.url == null && file.name != null) ? file.raw.url : file.url;
      const param = {
        objectId: file.url,
        bucketType: BucketType.WioaChecklist
      };
      this.$store.dispatch("common/removefile", param).then(() => {
        if(uploadElement.classList.contains('dependentSpouse'))
        {
          this.dislocatedWorker.categoryFour.dependentSpouse.clientFiles = [];
        }
        this.$message.success("Document removed!");
      })
      .catch((res) => {
      })
      .finally(() => {
        this.loading = false;
      });
    },
    handleExceed(){
      this.showPopUpMessage(
          "Upload",
          `You can only upload 1 file.`
        );
    },
    closeDisplacedHomeMakerDialog() {
      this.displayDisplacedHomeMakerDialog = false;
    },
    showDisplacedHomeMakerDialog() {
      this.displayDisplacedHomeMakerDialog = true;
    },
    getChecklistId() {
      return this.$route.params.checklistId;
    },
    backToDashboard() {
      this.$router.push({
        name: "WioaChecklistEight",
        params: { checklistId: this.getChecklistId() }
      });
    },
    updateCheckList() {
      this.loading = true;
      let checklist = {
        type: 3.4,
        checklist: {
          id:
            this.editChecklistId == null
              ? this.getChecklistId()
              : this.editChecklistId,
          dislocatedWorker: this.dislocatedWorker
        }
      };
      this.$store
        .dispatch("wioa/completeCheckList", checklist)
        .then(res => {
          if (res) {
            this.$router.push({
              name: "WioaChecklistTen",
              params: { checklistId: this.getChecklistId() }
            });
          }
        })
        .catch(res => {
          this.modelState = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    uploadDocument(param) {
      this.loading = true;

      this.$store
        .dispatch(
          "wioa/generateUploadDocumentMetadata",
          this.editChecklistId == null
            ? this.getChecklistId()
            : this.editChecklistId
        )
        .then(metadata => {
          this.storeDocument(param, metadata);
        })
        .catch(err => param.onError(err, param.file, param.fileList));
    },
    storeDocument(param, metadata) {
      const { file } = param;
      const fileExtension = utils.getFileExtension(file.name);

      this.$store
        .dispatch("common/uploadDocumentWithReturnUrl", {
          file,
          objectId:
            this.editChecklistId == null
              ? this.getChecklistId()
              : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
          bucketType: BucketType.WioaChecklist,
          fileExtension
        })
        .then(url => {
          this.document.id = metadata.documentId;
          this.document.filename = file.name;
          this.document.isImage = utils.isImage(file.name);
          this.document.documentObjectId = metadata.documentObjectId;
          this.document.documentObjectUrl = url;

          this.dislocatedWorker.categoryFour.dependentSpouse.clientFiles.push({
            fileId:
              this.editChecklistId == null
                ? this.getChecklistId()
                : this.editChecklistId + "/JobSeeker/" + metadata.documentId,
            fileName: file.name
          });
          this.newDependentSpouseUploadInd = true;
          param.file.url = this.editChecklistId == null
                  ? this.getChecklistId()
                  : this.editChecklistId + "/JobSeeker/" + metadata.documentId;
        })
        .catch(err => {
          param.onError(err, param.file, param.fileList);
        })
        .finally(() => (this.loading = false));
    },
    beforeUpload(file) {
      const fileExtension = utils.getFileExtension(file.name);

      if (this.validFileExtensions.indexOf(fileExtension) === -1) {
        this.showPopUpMessage(
          "Upload",
          `Invalid file type. Only ${this.validFileExtensions.join(
            ", "
          )} are allowed.`
        );
        this.loading = false;
        return false;
      }

      const fileLimitExceeded = file.size / 1024 / 1024 > 3;
      if (fileLimitExceeded) {
        this.showPopUpMessage("Upload", "File size cannot exceed 3MB");
        this.loading = false;
        return false;
      }

      return true;
    },
    onError() {
      this.loading = false;
      this.presignedUpdateUrl = "";

      this.document.id = "";
      this.document.filename = "";
      this.document.documentObjectId = "";
      this.document.documentObjectUrl = "";
      this.document.isImage = false;

      this.showPopUpMessage("Upload", "Unable to upload file.");
    },
    showPopUpMessage(title, msg, type = "error") {
      this.$confirm(msg, title, {
        confirmButtonText: "OK",
        type,
        showCancelButton: false,
        dangerouslyUseHTMLString: true,
        center: true
      }).then(() => false);
    },
    isImage(filename) {
      return utils.isImage(filename);
    }
  },
  computed: {
    currentPageStep() {
      return this.$route.meta.currentPage;
    },
    editChecklistId() {
      return localStorage.getItem("editChecklist");
    }
  }
};
</script>
